"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextCopy = void 0;
const outline_1 = require("@heroicons/react/24/outline");
const atoms_1 = require("../../atoms");
const react_1 = __importDefault(require("react"));
function TextCopy({ testId, text }) {
    return (react_1.default.createElement("div", { className: "mt-5", "data-testid": testId },
        react_1.default.createElement(atoms_1.Text, { type: atoms_1.TextType.UI_ELEMENT, className: "text-[12px] text-disabledTextColor pl-4 pb-1" }, "License key"),
        react_1.default.createElement("div", { className: "p-3 pl-4 w-full bg-transparent border border-borderColor rounded outline-none focus:ring-transparent flex justify-between" },
            react_1.default.createElement(atoms_1.Text, { type: atoms_1.TextType.UI_ELEMENT, subdued: true, forceCapitalization: false }, text),
            react_1.default.createElement(atoms_1.Tooltip, { content: "Copy", size: atoms_1.TooltipSize.XS },
                react_1.default.createElement(outline_1.DocumentDuplicateIcon, { onClick: () => {
                        navigator.clipboard.writeText(text);
                    }, className: "cursor-pointer stroke-[#788598] hover:stroke-defaultTextColor w-6 h-6" })))));
}
exports.TextCopy = TextCopy;
//# sourceMappingURL=TextCopy.js.map